module.exports = __webpack_public_path__ + "img/mv.711c100c.svg";